module.exports = __webpack_public_path__ + "img/guava-350x184.2af5596f.jpg";